<template>
  <v-subheader>{{ $t('labels.leads') }}</v-subheader>
</template>

<script>
export default { name: 'LeadHeader' }
</script>
